export default {
  common: {
    loading: '로딩 중...',
    noData: '데이터가 없습니다.',
  },
  nav: {
    home: '홈',
    products: '제품',
    about: '회사 소개',
    partnership: '파트너십',
    blog: '블로그',
  },
  home: {
    text: '홈',
    title: 'YOOXPLORE',
    hero: {
      title1: '글로벌 파트너 역량 강화',
      title2: '하늘에서 미래를 지킵니다',
      bookDemo: '데모 예약',
    },
  },
  overview: {
    title: '개요',
    subtitle: 'YOOX S3T UAV 플랫폼',
    content: 'YOOX S3T는 무거운 화물을 들어 올리고 안정적으로 비행하며 정밀하게 기동할 수 있는 첨단 무인 항공기(UAV)입니다. 현재 시장에서 최고의 자율 드론 중 하나로 설계되었으며, 긴 비행 시간과 우수한 장거리 성능을 갖추어 군사 작전, 산업 업무 및 인도주의적 임무에 이상적입니다.',
    content2: '드론 판매와 함께 귀사의 드론 브랜드가 현지에서 성공할 수 있도록 지원합니다. 현지화된 생산 및 조립 솔루션을 제공하여 귀사만의 생산 시스템을 구축하고 최고의 드론을 생산할 수 있도록 돕습니다.',
  },
  scenarios: {
    title: '적용 시나리오',
    subtitle: '더 많은 산업 활용 사례로 확장 가능',
  },
  advantages: {
    title: '핵심 장점',
    subtitle: '요구사항에 맞게 확장 설계',
  },
  products: {
    title: '제품 센터',
    intro: '제품 소개',
    subtitle: '산업용 비행 플랫폼 및 생태 제품',
    gallery: {
      all: '전체',
    },
    contact_business: '제품에 대한 자세한 내용은 저희에게 문의하세요',
  },
  about: {
    text: '회사 소개',
    title: '회사 소개',
    teamTitle: '우리 팀',
    teamSubtitle: '글로벌 선도 기업 출신',
    teamContent: '우리 팀은 DJI, Yamaha, Apple, Tesla 등의 기업 출신으로 구성되어 있으며, 드론 산업과 보안·방위 분야에서 평균 10년 이상의 경험을 보유하고 있습니다.',
    visionTitle: '우리의 비전',
    visionSubtitle: '귀사의 드론 브랜드를 현지에서 성공하도록 지원',
    visionContent: '드론 판매와 더불어 현지화 생산 및 조립 솔루션을 제공하여 귀사만의 생산 시스템을 구축하고 최고의 드론을 생산할 수 있도록 지원합니다.',
  },
  partnership: {
    title: '파트너십',
    primaryCta: '도매 & ODM & OEM',
    secondaryCta: '딜러 되기',
    qaTitle: '자주 묻는 질문',
  },
  blog: {
    title: '블로그',
    heading: '인사이트 & 업데이트',
    subheading: '드론, 현지화 및 시장 트렌드에 대한 최신 소식.',
    searchPlaceholder: '기사 검색',
  },
  contact: {
    title: '문의하기',
    title2: '여러분의 연락을 기다립니다.',
    content1: '더 많은 정보가 필요하시거나 협력을 원하시면 WhatsApp, Telegram 또는 양식을 통해 연락해 주세요.',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'Telegram',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: '문의 양식',
      subtitle: '여러분의 연락을 기다립니다.',
      firstName: '이름',
      lastName: '성',
      email: '이메일',
      phone: '전화번호',
      company: '회사',
      country: '국가/지역',
      interestLabel: '관심 있는 내용',
      interests: ['제품 구매', '딜러 되기', 'OEM/ODM', '기술 상담', '기타'],
      message: '요구사항 및 설명',
      submit: '제출',
      submitTip: '문의해 주셔서 감사합니다. 곧 연락드리겠습니다.',
      submitError: '제출 실패. 다시 시도해 주세요.',
    },
  },
}
